/* eslint-disable react/jsx-props-no-spreading */
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import { SWRConfig } from 'swr';
import H3 from '@base/H3/H3';
import H5 from '@base/H5/H5';
import { BatchType } from '@cont/BatchGroup/constants';
import { useSnackbar } from '@stores/snackbar';
import CurriculumSectionWithAccordion from './CurriculumSectionWithAccordion';
import CurriculumSection from './CurriculumSection';
import GuidedSection from './GuidedSection';
import useGuidedSection from '../useGuidedSection';

const CurriculumSectionWrapper = styled.div`
  margin-top: ${Spacings.SPACING_0B};
`;

const StyledH3 = styled(H3)`
  margin-bottom: ${Spacings.SPACING_6B};
`;
const StyledH5 = styled(H5)`
  margin-bottom: ${Spacings.SPACING_4B};
`;

const getIsHybridBatches = (classType = {}) => {
  return classType?.key === BatchType.hybridBatch;
};

const Curriculum = (props) => {
  const {
    batchGroupCourses,
    batch,
    title,
    subTitle,
    sendEventOnExpend,
    classType
  } = props;
  const hasCourse = batchGroupCourses?.schedule?.length;
  const hasSingleCourse = batchGroupCourses?.schedule?.length === 1;
  const { open: showSnackbar } = useSnackbar();
  const { schedule } = batchGroupCourses;
  const { batchGroup: batchGroupUID } = batch;
  const isHybrid = getIsHybridBatches(batch?.classType);
  const { lessonData } = useGuidedSection(batchGroupUID, classType);
  return (
    <SWRConfig
      value={{
        shouldRetryOnError: false,
        revalidateOnMount: false,
        onError: () => {
          showSnackbar({
            message: 'Something went wrong',
            type: 'error'
          });
        }
      }}
    >
      {isHybrid && <StyledH3>{title}</StyledH3>}
      <GuidedSection
        {...props}
        isHybrid={isHybrid}
        lessonData={lessonData}
        batchGroupUID={batchGroupUID}
      />
      {hasCourse && (
        <CurriculumSectionWrapper>
          {isHybrid ? (
            <StyledH5>{subTitle}</StyledH5>
          ) : (
            <StyledH3>{title}</StyledH3>
          )}
          {hasSingleCourse ? (
            <CurriculumSection
              {...props}
              course={schedule[0]}
              batchGroupUID={batchGroupUID}
            />
          ) : (
            <CurriculumSectionWithAccordion
              {...props}
              batchGroupUID={batchGroupUID}
              batchGroupCourses={batchGroupCourses}
              sendEventOnExpend={sendEventOnExpend}
            />
          )}
        </CurriculumSectionWrapper>
      )}
    </SWRConfig>
  );
};

export default Curriculum;
